module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-BookItalic-b12736ca80669e3f46c6df4432f767de.ttf";